module.exports = require('./lib/ReactWithAddons');



/*****************
 ** WEBPACK FOOTER
 ** ./~/react/addons.js
 ** module id = 35
 ** module chunks = 0
 **/